<template>
  <div v-if="ActiveHost === null">Loading...</div>
  <component v-else :is="ActiveComponent" />
</template>

<script>
export default {
  data() {
    return {
      ActiveComponent: null,
      ActiveHost: null,
    };
  },
  methods: {
    UpdateRelatedComponent() {
      if (this.$route.meta.host === undefined) {
        return;
      }
      if (this.ActiveHost === this.$route.meta.host) {
        return;
      }
      this.ActiveComponent = this.$route.meta.base;
      this.ActiveHost = this.$route.meta.host;
    },
  },
  mounted() {
    this.UpdateRelatedComponent();
  },
  watch: {
    $route: 'UpdateRelatedComponent',
  },
};
</script>
<style>
.hoverDarkLight:not(:hover) .isDark,
.hoverDarkLight:hover .isLight {
  display: inline-block;
}
.hoverDarkLight:hover .isDark,
.hoverDarkLight:not(:hover) .isLight {
  display: none;
}
.row.justify-content {
  justify-content: center;
  display: flex;
}
</style>